export default __webpack_public_path__ + "static/media/collapse.da8a0f55.svg";